import React, { useState, useEffect } from 'react';
import axios from 'axios';
import APIEndPoints from '../../../middleware/APIEndPoints';

const Skills = () => {
  const cloudinaryURL = process.env.REACT_APP_CLOUDINARY_URL;
  console.log(cloudinaryURL)
  const [skills, setSkills] = useState([]);
  const [newSkill, setNewSkill] = useState({
    title: '',
    description: '',
    image: ''
  });
  const [editSkill, setEditSkill] = useState({
    title: '',
    description: '',
    image: ''
  });
  const [editSkillId, setEditSkillId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const getSkillsURL = APIEndPoints.skills.url;


  // Fetch all skills on mount
  useEffect(() => {
    const fetchSkills = async () => {
      try {
        const res = await axios.get(getSkillsURL);
        setSkills(res.data);
      } catch (error) {
        console.error('Error fetching skills', error);
      }
    };
    fetchSkills();
  }, []);

  // Cloudinary image upload
  const handleImageUpload = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'upload'); // Add your preset here

    try {
      const res = await axios.post(cloudinaryURL, formData);
      return res.data.secure_url; // Returns the uploaded image URL
    } catch (error) {
      console.error('Error uploading image', error);
    }
  };

  // Handle adding a new skill
  const handleAddSubmit = async (e) => {
    e.preventDefault();
    try {
      let imageUrl = newSkill.image;
      if (newSkill.image instanceof File) {
        imageUrl = await handleImageUpload(newSkill.image);
      }

      const skillData = {
        title: newSkill.title,
        description: newSkill.description,
        image: imageUrl
      };

      // Create new skill
      const res = await axios.post(getSkillsURL, skillData);
      setSkills([...skills, res.data]);

      // Reset the form
      setNewSkill({ title: '', description: '', image: '' });
    } catch (error) {
      console.error('Error submitting skill', error);
    }
  };

  // Handle editing an existing skill
  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    try {
      let imageUrl = editSkill.image;
      if (editSkill.image instanceof File) {
        imageUrl = await handleImageUpload(editSkill.image);
      }

      const updatedSkillData = {
        title: editSkill.title,
        description: editSkill.description,
        image: imageUrl
      };

      // Update existing skill
      await axios.put(`${getSkillsURL}/${editSkillId}`, updatedSkillData);
      setSkills((prevSkills) =>
        prevSkills.map((skill) =>
          skill._id === editSkillId ? { ...skill, ...updatedSkillData } : skill
        )
      );

      // Reset the form and editing state
      setEditSkill({ title: '', description: '', image: '' });
      setEditSkillId(null);
      setIsEditing(false);
    } catch (error) {
      console.error('Error updating skill', error);
    }
  };

  // Handle delete operation
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${getSkillsURL}/${id}`);
      setSkills(skills.filter((skill) => skill._id !== id));
    } catch (error) {
      console.error('Error deleting skill', error);
    }
  };

  // Populate form for editing
  const handleEdit = (skill) => {
    setEditSkill({
      title: skill.title,
      description: skill.description,
      image: skill.image
    });
    setEditSkillId(skill._id);
    setIsEditing(true);
  };

  return (
    <div className="bg-[#1d0c39]  skills-container p-4">
      <h1 className="text-2xl font-bold py-2">Skills</h1>

      {/* Add Skill Form */}
      <h2 className="text-xl font-bold">Add a New Skill</h2>
      <form onSubmit={handleAddSubmit} className="flex flex-col space-y-4">
        <input
          type="text"
          placeholder="Title"
          className="text-black"
          value={newSkill.title}
          onChange={(e) => setNewSkill({ ...newSkill, title: e.target.value })}
        />
        <textarea
          placeholder="Description"
          className="text-black"
          value={newSkill.description}
          onChange={(e) =>
            setNewSkill({ ...newSkill, description: e.target.value })
          }
        />
        <input
          type="file"
          onChange={(e) =>
            setNewSkill({ ...newSkill, image: e.target.files[0] })
          }
        />
        <button type="submit" className="btn">Add Skill</button>
      </form>

      {/* Edit Skill Form */}
      {isEditing && (
        <>
          <h2 className="text-xl font-bold mt-8">Edit Skill</h2>
          <form onSubmit={handleUpdateSubmit} className="flex flex-col space-y-4">
            <input
              type="text"
              placeholder="Title"
              className="text-black"
              value={editSkill.title}
              onChange={(e) => setEditSkill({ ...editSkill, title: e.target.value })}
            />
            <textarea
              placeholder="Description"
              className="text-black"
              value={editSkill.description}
              onChange={(e) =>
                setEditSkill({ ...editSkill, description: e.target.value })
              }
            />
            <input
              type="file"
              onChange={(e) =>
                setEditSkill({ ...editSkill, image: e.target.files[0] })
              }
            />
            <button type="submit" className="btn">Update Skill</button>
          </form>
        </>
      )}

      {/* Display list of skills */}
      <div className="skills-list mt-8">
        {skills.map((skill) => (
          <div key={skill._id} className="skill-card">
            <img src={skill.image} alt={skill.title} />
            <h3>{skill.title}</h3>
            <p>{skill.description}</p>
            <button onClick={() => handleEdit(skill)}>Edit</button>
            <button onClick={() => handleDelete(skill._id)}>Delete</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;
